<template>
    <div>
        <div class="modal_header">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24">
                    <div class="grid-content bg-purple">
                        <div class="title_h">
                            {{ $t('message.show_conclusions') }}
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24">
                    <div class="grid-content bg-purple-light">
                        <el-row class="button_r">
                            <el-button v-can="'printCenter.print'" :loading="waitingPrint"  @click="print('hospitalizationConclusions/print', model.id)">{{ $t('message.print') }}</el-button>
                            <el-button @click="resetForm('form')">{{ $t('message.close') }}</el-button>
                        </el-row>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="row">
            <div class="col-12 mt-2">
                <div class="modal-body">
                    <el-row>
                        <el-col class="ml-5" :span="8">
                            {{ $t('message.doctor_name') }} : <b>
                                {{ model.doctor ? ( (model.doctor.surname ? model.doctor.surname :'')+ ' ' + model.doctor.name + ' ' + (model.doctor.patronymic ? model.doctor.patronymic :'')) : ''}}
                            </b>
                        </el-col>
                        <el-col :span="8">
                            {{ $t('message.date') }} : <b>
                                {{ model.date_time ? model.date_time : '-' }}
                            </b>
                        </el-col>
                        <el-divider></el-divider>
                        <el-col :span="24">
                            <el-card class="ml-5" style="width:826px" shadow="always">
                                <div class="content-table" v-html="model.content"></div>
                            </el-card>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters,mapActions} from 'vuex'
    import form from '@/utils/mixins/form';
    import print from '@/utils/mixins/print';
    export default {
        mixins: [form,print],
        props: {
            reloadModel: {type: Boolean, default: true}
        },
        data(){
            return {
                waitingPrint: false
            }
        },
        watch: {
            reloadModel: {
                handler: function () {
                    if (this.reloadModel){
                        this.loadModel()
                    }
                },
                deep: true
            },
        },
        created(){},
        async mounted(){
        },
        computed: {
            ...mapGetters({
                rules: 'hospitalizationConclusions/rules',
                model: 'hospitalizationConclusions/model',
                columns: 'hospitalizationConclusions/columns',
            })
        },
        methods:{
            ...mapActions({
                save: 'hospitalizationConclusions/update',
            }),
            loadModel(){
                this.form = JSON.parse( JSON.stringify( this.model ));
            },
            submit(close = true){
                this.$refs['form'].validate((valid) => {
                    if (valid){
                        this.loadingButton = true;
                        this.save(this.form)
                            .then(res => {
                                this.loadingButton = false;
                                this.$emit('c-close',{drawer: 'drawerUpdate'});
                                this.$notify({
            title: 'Успешно',
            type: "success",
            offset: 130,
            message: res.message
          });
                                this.$refs['form'].resetFields();
                            })
                            .catch(err => {
                                this.loadingButton = false;
                                this.$notify({
        title: 'Ошибка',
        type: "error",
        offset: 130,
        message: err.error.message
      });
                            });
                    }
                });
            },
            resetForm(formName) {
                this.$emit('c-close',{drawer: 'drawerUpdate'});
            },

        }
    }

</script>
